/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import SectionNav from 'components/section-nav';
import NavTabs from 'components/section-nav/tabs';
import NavItem from 'components/section-nav/item';

/**
 * Style dependencies
 */
import './styles.scss';

const Navigation = (props) => {
    return (
        <Box>
            <SectionNav>
                <NavTabs>
                    <NavItem path={'/settings/locations'} selected={props.section === 'locations'}>
                        Locations
                    </NavItem>
                    <NavItem path={'/settings/data'} selected={props.section === 'data'}>
                        Data
                    </NavItem>
                    <NavItem path={'/settings/ftp'} selected={props.section === 'ftp'}>
                        FTP
                    </NavItem>
                </NavTabs>
            </SectionNav>
        </Box>
    );
};

export default Navigation;
